<script lang="ts">
  import { FormGroup, Input, Label } from "sveltestrap";
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
</script>
<FormGroup>
    <Label for="inputState">{'Country'}</Label>
    <Input type="select" required name="select" id="exampleSelect" value="Choose...">
        <option>{'Choose...'}</option>
        <option>...</option>
    </Input>
</FormGroup>
{#each data.formfileddata as formItem}
    <FormGroup>
        <Label for={formItem.id}>{formItem.label}</Label>
        <Input id={formItem.id} required type="text" />
    </FormGroup>
{/each}
<FormGroup>
    <Input id="gridCheck" type="checkbox" label="Check me out" />
</FormGroup>